<template>
  <div class="workflow-container" ref="workflowRef">
    <button class="download-btn" @click="downloadImage">
      <span class="download-icon">⬇ png</span>
    </button>
    <h2 class="workflow-title">Luồng Phê Duyệt</h2>
    <div class="timeline">
      <!-- Start Node -->
      <div class="timeline-item">
        <div class="node start-node">
          <span class="node-icon">🚀</span>
          Bắt đầu
        </div>
        <div class="timeline-line"></div>
      </div>

      <!-- Tờ trình Node -->
      <div class="timeline-item">
        <div class="node to-trinh-node" :class="getStatusClass(data.to_trinh.trang_thai)">
          <span class="node-icon">📄</span>
          Tờ trình: {{ data.to_trinh.ten }}
          <span class="status-badge">{{ data.to_trinh.trang_thai }}</span>
        </div>
        <div class="timeline-line"></div>
      </div>

      <!-- Nhóm duyệt -->
      <div v-for="(nhom, index) in data.nhom_duyet" :key="index" class="timeline-item">
        <div class="node nhom-duyet-node">
          <span class="node-icon">👥</span>
          Nhóm: {{ nhom.ten_nhom }}
        </div>
        <div class="group-container">
          <div v-for="(nguoi, idx) in nhom.nguoi_duyet" :key="idx" class="person-container">
            <div class="node nguoi-duyet-node" :class="getStatusClass(nguoi.trang_thai)">
              <span class="node-icon">{{ getStatusIcon(nguoi.trang_thai) }}</span>
              Người duyệt: {{ nguoi.ten }}
              <span class="status-badge">{{ nguoi.trang_thai }}</span>
            </div>
          </div>
        </div>
        <div class="timeline-line"></div>
      </div>

      <!-- End Node -->
      <div class="timeline-item">
        <div class="node end-node">
          <span class="node-icon">🏁</span>
          Kết thúc
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import html2canvas from 'html2canvas';

// Dữ liệu mẫu JSON
const data = {
  to_trinh: {
    ten: 'Tờ trình mua sắm thiết bị văn phòng',
    trang_thai: 'Đang duyệt',
  },
  nhom_duyet: [
    {
      ten_nhom: 'Nhóm 1 - Phòng Hành chính',
      nguoi_duyet: [
        { ten: 'Nguyễn Văn A', trang_thai: 'Đã duyệt' },
        { ten: 'Trần Thị B', trang_thai: 'Đang duyệt' },
      ],
    },
    {
      ten_nhom: 'Nhóm 2 - Phòng Tài chính',
      nguoi_duyet: [{ ten: 'Lê Văn C', trang_thai: 'Chưa duyệt' }],
    },
    {
      ten_nhom: 'Nhóm 3 - Ban Giám đốc',
      nguoi_duyet: [
        { ten: 'Phạm Thị D', trang_thai: 'Chưa duyệt' },
        { ten: 'Hoàng Văn E', trang_thai: 'Từ chối' },
      ],
    },
    {
      ten_nhom: 'Nhóm 4 - Phòng Kế hoạch',
      nguoi_duyet: [{ ten: 'Vũ Văn F', trang_thai: 'Chưa duyệt' }],
    },
  ],
};

// Ref để tham chiếu DOM
const workflowRef = ref(null);

// Hàm tải xuống ảnh
const downloadImage = async () => {
  if (workflowRef.value) {
    try {
      const canvas = await html2canvas(workflowRef.value, {
        backgroundColor: null, // Giữ gradient nền
        scale: 2,
      });
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'approval-flow.png';
      link.click();
    } catch (error) {
      console.error('Lỗi khi tải ảnh:', error);
      alert('Không thể tải ảnh, vui lòng thử lại.');
    }
  }
};

// Hàm trả về class dựa trên trạng thái
const getStatusClass = (trang_thai) => {
  return {
    'Chưa trình duyệt': 'chua-duyet',
    'Đang duyệt': 'dang-duyet',
    'Đã duyệt': 'da-duyet',
    'Từ chối': 'tu-choi',
  }[trang_thai] || '';
};

// Hàm trả về icon dựa trên trạng thái
const getStatusIcon = (trang_thai) => {
  return {
    'Chưa trình duyệt': '⏳',
    'Đang duyệt': '⏰',
    'Đã duyệt': '✅',
    'Từ chối': '❌',
  }[trang_thai] || '📌';
};
</script>

<style scoped>
.workflow-container {
  max-width: 1000px;
  margin: 10px auto;
  background: linear-gradient(135deg, #ffffff 0%, #ffffff 100%);
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  position: relative;
}

.workflow-title {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 30px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.node {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-width: 220px;
  text-align: center;
}

.node:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.node-icon {
  font-size: 20px;
}

.status-badge {
  margin-left: 10px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1));
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.start-node {
  background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
}

.end-node {
  background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
}

.to-trinh-node {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  font-weight: 700;
  min-width: 320px;
}

.nhom-duyet-node {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
}

.nguoi-duyet-node {
  background: linear-gradient(135deg, #22d3ee 0%, #06b6d4 100%);
}

.chua-duyet {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
  color: #000 !important;
}

.dang-duyet {
  background: linear-gradient(135deg, #fb923c 0%, #f97316 100%) !important;
  color: #fff !important;
}

.da-duyet {
  background: linear-gradient(135deg, #34d399 0%, #10b981 100%) !important;
}

.tu-choi {
  background: linear-gradient(135deg, #f87171 0%, #ef4444 100%) !important;
}

.timeline-line {
  width: 6px;
  height: 50px;
  background: linear-gradient(180deg, #d1d5db 0%, #93c5fd 100%);
  margin: 15px 0;
  border-radius: 3px;
}

.group-container {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: center;
  margin: 25px 0;
  padding: 15px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.person-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.download-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  border: none;
  border-radius: 8px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.3s ease, background 0.3s ease, box-shadow 0.3s ease;
}

.download-btn:hover {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  transform: scale(1.05);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.25);
}

.download-icon {
  font-size: 18px;
}

@media (max-width: 768px) {
  .workflow-container {
    margin: 20px;
    padding: 30px;
  }

  .workflow-title {
    font-size: 24px;
  }

  .node {
    font-size: 14px;
    min-width: 200px;
    padding: 12px 18px;
  }

  .to-trinh-node {
    min-width: 280px;
  }

  .group-container {
    flex-direction: column;
    align-items: center;
  }

  .timeline-line {
    height: 40px;
  }

  .download-btn {
    top: 15px;
    right: 15px;
    font-size: 14px;
    padding: 8px 16px;
  }

  .download-icon {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .workflow-container {
    margin: 10px;
  }

  .workflow-title {
    font-size: 20px;
  }

  .node {
    font-size: 12px;
    min-width: 180px;
    padding: 5px 7px;
  }

  .to-trinh-node {
    min-width: 240px;
  }

  .node-icon {
    font-size: 18px;
  }

  .status-badge {
    font-size: 10px;
    padding: 4px 8px;
  }

  .timeline-line {
    height: 30px;
  }

  .download-btn {
    top: 10px;
    right: 10px;
    font-size: 12px;
    padding: 6px 12px;
  }

  .download-icon {
    font-size: 14px;
  }
}
</style>